









import {Component, Prop} from "vue-property-decorator";
import CommonBase from "../CommonBase";

@Component
export default class ReportPagination extends CommonBase {
    @Prop()
    page!: number;
    @Prop()
    rowsPerPage!: number;
    @Prop()
    rowCount!: number;
    @Prop()
    hasMore!: boolean;

    get fromRow() {
        if(this.page === 1 && this.rowCount === 0) {
            return 0;
        }
        return ((this.page - 1) * this.rowsPerPage) + 1;
    }

    get toRow() {
        if(this.hasMore) {
            return this.fromRow + this.rowsPerPage - 1;
        } else if(this.fromRow === 0) {
            return 0;
        } else {
            return this.fromRow + this.rowCount - 1;
        }
    }

    nextPage() {
        this.$emit("next-page");
    }
    prevPage() {
        this.$emit("prev-page");
    }
}
